export default {
    clearActionButtonLoader() {
        if (this.loadingTimeoutId != null) {
            clearTimeout(this.loadingTimeoutId);
            this.loadingTimeoutId = null;
        }
        if (this.loadingButton && this.loadingButton.length) {
            const $btn = this.loadingButton;
            this.loadingButton = null;
            $btn.removeClass('action-btn-loading action-btn-pressed').prop('disabled', false).find('.action-btn-spinner').remove();
        }
    },

    setActionButtonLoading($btn, onClick) {
        const self = this;
        this.clearActionButtonLoader();
        this.loadingButton = $btn;
        $btn.addClass('action-btn-pressed');
        requestAnimationFrame(() => {
            $btn.addClass('action-btn-loading').prop('disabled', true);
            $btn[0].blur();
            $btn.append(this.buildSpinnerEl());
            self.loadingTimeoutId = setTimeout(() => {
                self.loadingTimeoutId = null;
                self.clearActionButtonLoader();
            }, self.LOADER_CLEAR_MS);
            $(document).one('shown.bs.modal', () => self.clearActionButtonLoader());
            setTimeout(() => {
                const result = onClick();
                if (result && typeof result.then === 'function') {
                    result.finally(() => self.clearActionButtonLoader());
                }
            }, 0);
        });
    },

    buildSpinnerEl() {
        return $('<span>').addClass('action-btn-spinner').attr('aria-hidden', 'true')
            .append($('<i>').addClass('fa fa-spinner fa-spin').attr('aria-hidden', 'true'));
    },

    setLoadingState($container, message) {
        const $pill = $('<span>').addClass('payment-details-loading__pill')
            .append($('<span>').addClass('row-expander-spinner').attr('aria-hidden', 'true'))
            .append($('<span>').text(message));
        $container.empty().addClass('payment-details-loading').append($pill);
    },

    setErrorState($container, message) {
        $container.empty().removeClass('payment-details-loading')
            .append($('<div>').addClass('text-danger').text(message));
    },

    renderDetailPanelContent($container, $content) {
        const $scroll = $('<div>').addClass('detail-panel-scroll').append($content);
        $container.empty().removeClass('payment-details-loading').append($scroll);
    },

    renderRelationshipsPanelHtml($container, fragmentHtml) {
        const trimmed = fragmentHtml ? String(fragmentHtml).trim() : '';
        const $body = trimmed ? $(trimmed) : $('<div>').addClass('detail-list-empty text-muted').text('No card available.');
        const $scroll = $('<div>').addClass('detail-panel-scroll member-expand-relationships-scroll').append($body);
        $container.empty().removeClass('payment-details-loading').append($scroll);
    },

    setExpandSectionDisabled($panelRoot, disabled, actionNames = null) {
        const $section = $($panelRoot).closest(
            '.member-expand-panel, .pledge-detail-user-column, .pledge-detail-payment-column'
        );
        if (!$section.length) {
            return;
        }
        const shouldDisableAction = (action) => !actionNames || actionNames.includes(action);

        $section.find('[data-action]').each(function () {
            const $el = $(this);
            const action = $el.data('action');
            if (!shouldDisableAction(action)) {
                return;
            }
            if (disabled) {
                $el.addClass('disabled').attr({ 'aria-disabled': 'true', tabindex: '-1' });
                if ($el.is('button')) {
                    $el.prop('disabled', true);
                }
            } else {
                $el.removeClass('disabled').removeAttr('aria-disabled').removeAttr('tabindex');
                if ($el.is('button')) {
                    $el.prop('disabled', false);
                }
            }
        });
        $section.find('.member-expand-preview-host').each(function () {
            const $host = $(this);
            const overlayAction = $host.find('.member-expand-preview-host__overlay-btn').data('action');
            if (!shouldDisableAction(overlayAction)) {
                return;
            }
            $host.toggleClass('member-expand-preview-host--overlay-disabled', disabled);
        });
    },
};
